import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allFieldsSelector } from 'redux/schemaSlice';
import {
  hasDateTimeSelector,
  dateFormatSelector,
  dateFormattingStringSelector,
  startTimeFieldSelector,
  endTimeFieldSelector,
  hasDateTimeSet,
  dateFormatSet,
  dateFormattingStringSet,
  startTimeFieldSet,
  endTimeFieldSet
} from 'redux/keyFieldsSlice';
import { derivedSamplesSelector } from 'redux/schemaSlice';

import DateTimeFormatHelp from 'components/DateTimeFormatHelp';
import Select from 'components/Select';

import {
  Form,
  FormControl,
  Heading,
  StyledPanel
} from 'components/StyledComponents';
import {
  StyledTextField,
  DatetimeFieldSelectWrapper,
  SampleValueContainer
} from './DateTimeSettings-styled';

import { CalciteLabel, CalciteOption } from 'components/Calcite';

const TrackingField: React.FC = () => {
  const dispatch = useDispatch();

  const hasDateTime = useSelector(hasDateTimeSelector);
  const dateFormat = useSelector(dateFormatSelector);
  const dateFormattingString = useSelector(dateFormattingStringSelector);
  const allFields = useSelector(allFieldsSelector);
  const startTimeField = useSelector(startTimeFieldSelector);
  const endTimeField = useSelector(endTimeFieldSelector);
  const samples = useSelector(derivedSamplesSelector);

  return (
    <StyledPanel>
      <Heading>Date and time</Heading>
      <Form>
        <FormControl>
          <CalciteLabel>Does your data have date fields?</CalciteLabel>
          <Select
            label="datetime"
            onChange={value => dispatch(hasDateTimeSet(value === 'true'))}
            options={[
              <CalciteOption key="yes" selected={hasDateTime} value="true">
                Yes
              </CalciteOption>,
              <CalciteOption
                key="no"
                selected={hasDateTime === false}
                value="false"
              >
                No
              </CalciteOption>
            ]}
            value={hasDateTime?.toString()}
          />
        </FormControl>
        {hasDateTime && (
          <>
            <DatetimeFieldSelectWrapper>
              <FormControl>
                <CalciteLabel>Start time (optional)</CalciteLabel>
                <Select
                  label="start time"
                  onChange={value =>
                    dispatch(startTimeFieldSet(value as string))
                  }
                  options={[
                    <CalciteOption key="__NONE__" value="__NONE__">
                      None
                    </CalciteOption>,
                    ...allFields.map(({ fieldName, displayName }) => (
                      <CalciteOption key={fieldName} value={fieldName}>
                        {displayName}
                      </CalciteOption>
                    ))
                  ]}
                  value={startTimeField}
                />
              </FormControl>
              {startTimeField && startTimeField !== '__NONE__' && (
                <SampleValueContainer>
                  {String(samples[0].attributes[startTimeField])}
                </SampleValueContainer>
              )}
            </DatetimeFieldSelectWrapper>
            {startTimeField && startTimeField !== '__NONE__' ? (
              <DatetimeFieldSelectWrapper>
                <FormControl>
                  <CalciteLabel>End time (optional)</CalciteLabel>
                  <Select
                    label="end time"
                    onChange={value =>
                      dispatch(endTimeFieldSet(value as string))
                    }
                    options={[
                      <CalciteOption key="__NONE__" value="__NONE__">
                        None
                      </CalciteOption>,
                      ...allFields.map(({ fieldName, displayName }) => (
                        <CalciteOption key={fieldName} value={fieldName}>
                          {displayName}
                        </CalciteOption>
                      ))
                    ]}
                    value={endTimeField}
                  />
                </FormControl>
                {endTimeField && endTimeField !== '__NONE__' && (
                  <SampleValueContainer>
                    {String(samples[0].attributes[endTimeField])}
                  </SampleValueContainer>
                )}
              </DatetimeFieldSelectWrapper>
            ) : null}
            <FormControl>
              <CalciteLabel>Date Format</CalciteLabel>
              <Select
                label="date format"
                onChange={value => dispatch(dateFormatSet(value as string))}
                value={dateFormat!}
                options={[
                  <CalciteOption
                    key="epoch"
                    selected={dateFormat === 'epoch'}
                    value="epoch"
                  >
                    Epoch values
                  </CalciteOption>,
                  <CalciteOption
                    key="other"
                    selected={dateFormat === 'other'}
                    value="other"
                  >
                    Other (string)
                  </CalciteOption>
                ]}
              />
            </FormControl>
            {dateFormat === 'other' && (
              <FormControl>
                <CalciteLabel>Date Formatting String</CalciteLabel>
                <StyledTextField
                  placeholder="Enter a date format..."
                  value={dateFormattingString || ''}
                  onChange={value => dispatch(dateFormattingStringSet(value))}
                />
                <DateTimeFormatHelp />
              </FormControl>
            )}
          </>
        )}
      </Form>
    </StyledPanel>
  );
};

export default TrackingField;
